/**
* 左边菜单
*/
<template>
  <el-menu default-active="2" :collapse="collapsed" collapse-transition router :default-active="$route.path" unique-opened
    class="el-menu-vertical-demo" background-color="#334157" text-color="#fff" active-text-color="#ffd04b">
    <!-- <div class="logobox">
      <img class="logoimg" src="../assets/img/logo.png" alt="">
    </div> -->
    <div v-for="menu in allmenu" :key="menu.menuId">
      <el-menu-item v-if="!menu.children.length" :index="menu.routingAddress" :key="menu.menuId">
        <i class="iconfont" :class="menu.menuIcon || 'icon-cms-manage'"></i>
        <span v-if="!collapsed"> {{ menu.menuName }}</span>
      </el-menu-item>
      <el-submenu v-else :index="menu.menuName">
        <template slot="title">
          <i class="iconfont" :class="menu.menuIcon || 'li-icon-xitongguanli'"></i>
          <span v-if="!collapsed">{{ menu.menuName }}</span>
        </template>
        <el-menu-item-group>
          <el-menu-item v-for="chmenu in menu.children" :index="chmenu.routingAddress" :key="chmenu.menuId">
            <i class="iconfont" :class="chmenu.menuIcon || 'icon-cms-manage'"></i>
            <span>{{ chmenu.menuName }}</span>
          </el-menu-item>
        </el-menu-item-group>
      </el-submenu>
    </div>
  </el-menu>
</template>
<script>
import { menu } from '../api/userMG'
import store from "@/vuex/store";
export default {
  name: 'leftnav',
  data () {
    return {
      collapsed: false,
      allmenu: []
    }
  },
  computed: {
    isEdit () {
      return this.$store.state.menuList;　　//需要监听的数据
    }
  },
  watch: {
    isEdit (newVal, oldVal) {
      this.allmenu = this.traversalMenu(newVal)
    },
  },
  // 创建完毕状态(里面是操作)
  created () {
    this.$root.Bus.$on('toggle', value => {
      this.collapsed = !value;
      this.$forceUpdate()
    });
    this.allmenu = this.traversalMenu(store.state.menuList)
  },
  methods: {
    traversalMenu (menuList) {
      menuList.forEach(element => {
        if (element.children.length) {
          element.children = this.traversalMenu(element.children)
        };
      });
      return menuList.filter(item => item.type == "MENU" || item.type == "PAGE")
    }
  }
}
</script>
<style>
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 240px;
  min-height: 400px;
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  border: none;
  text-align: left;
}

.el-menu-item-group__title {
  padding: 0px;
}

.el-menu-bg {
  background-color: #1f2d3d !important;
}

.el-menu {
  border: none;
}

.logobox {
  height: 40px;
  line-height: 40px;
  color: #9d9d9d;
  font-size: 20px;
  text-align: center;
  padding: 20px 0px;
}

.logoimg {
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/leftnav.vue